<template>
  <div>

    <v-container fluid>
      <v-card v-if="!viewAnswer" style="border-radius: 16px; padding: 15px">
        <div v-for="(item1, i) in section_Items" :key="i">
          <v-row>
            <v-col cols="12" class="d-flex justify-space-between">
              <span style="font-size: 32px; color: #424242">{{
                item1.sectionName
              }}</span>
              <div
                v-if="remainingTime !== 0"
                class="d-flex justify-center align-center"
                style="
                  width: 257px;
                  height: 52px;
                  border: 2px solid #d52a2a;
                  border-radius: 10px;
                  color: #d52a2a;
                  font-size: 20px;
                "
              >
                {{ formatTime(remainingTime) }} {{ $t("minutes") }}
              </div>
            </v-col>
            <v-col cols="12" class="pt-0">
              <span style="font-size: 20px; color: #616161">{{
                item1.sectionDescription
              }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-card
                v-for="item2 in item1.questionList"
                :key="item2.questionId"
                style="
                  background-color: #42424208;
                  border-radius: 8px;
                  box-shadow: unset;
                "
                class="mb-7"
              >
                <!-- Quiz's Question -->
                <v-row class="ma-1 ml-0">
                  <v-col cols="12" md="10" style="padding: 0 30px 10px 17px">
                    <span style="font-size: 20px; color: #424242">{{
                      item2.question
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    style="text-align: right; padding: 20px 16px 10px 0"
                  >
                    <span style="font-size: 16px; color: #616161">{{
                      item2.questionScore + " " + $t("score")
                    }}</span>
                  </v-col>
                </v-row>

                <v-divider
                  class="ml-4 mr-4"
                  style="border-color: #7070707f"
                ></v-divider>

                <!-- Question image -->
                <v-row v-if="item2.questionImge" class="mt-3 ml-1">
                  <v-col class="pb-2" cols="12" lg="5" xl="5">
                    <v-img
                      class="ml-5"
                      :aspect-ratio="15 / 10"
                      :width="445"
                      @click="showImgPreview(item2.questionImge)"
                      :src="item2.questionImge"
                    ></v-img>
                  </v-col>
                </v-row>

                <!-- Question content -->
                <v-row v-if="item2.subjectiveFlag" class="ma-3">
                  <v-col cols="12">
                    <!-- Show textarea for subjective questions -->
                    <v-textarea
                      v-model="item2.userEssayAnswer"
                      label="Your answer"
                      rows="5"
                      outlined
                      color="#4FB14E"
                      @input="item2.ansNotSubmit = false"
                      
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row v-else class="ma-1">
                  <!-- Objective Questions -->
                  <v-col
                    v-if="!item2.choiceList.some((x) => x.choiceImge)"
                    class="pt-1 pb-3"
                  >
                    <v-list style="background: transparent">
                      <v-list-item-group multiple class="option_sheet">
                        <template v-for="item in item2.choiceList">
                          <v-list-item v-if="item" :key="item.choiceId">
                            <v-list-item-action>
                              <v-checkbox
                                v-if="item2.multipleChoice === true"
                                v-model="item.userAnswer"
                                @click="
                                  checkCorrectAns(
                                    item2.questionId,
                                    item.choiceId
                                  )
                                "
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-radio-group
                                v-else
                                hide-details
                                class="mt-0 pt-0"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    item.userAnswer = true;
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    );
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-list-item-action>

                            <v-list-item-content
                              v-if="item"
                              style="padding-right: 26px"
                            >
                              <span style="font-size: 16px; color: #424242">{{
                                item.choice
                              }}</span>
                              <v-img
                                v-if="item.choiceImge"
                                :key="item.choiceId + 1"
                                class="mb-3"
                                :aspect-ratio="16 / 9"
                                :width="170"
                                @click="showImgPreview(item.choiceImge)"
                                :src="item.choiceImge"
                              ></v-img>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col v-else class="pb-4 pt-1">
                    <v-row dense class="d-flex flex-wrap" justify="space-between">
                      <v-radio-group
                        v-if="!item2.multipleChoice"
                        v-model="item2.radio_UserChoice"
                        row
                        class="w-100"
                        @change="onRadioChange(item2)"
                      >
                        <v-col
                          v-for="item in item2.choiceList"
                          :key="item.choiceId"
                          cols="auto"
                          class="d-flex flex-column align-center pa-2 ma-3"
                          style="margin-bottom: 16px;"
                        >
                          <v-radio
                            :value="item.choiceId"
                            :label="item.choice"
                            hide-details
                            color="#4FB14E"
                            class="mb-2"
                          ></v-radio>

                          <v-img
                            v-if="item.choiceImge"
                            :src="item.choiceImge"
                            :width="100"
                            :height="80"
                            class="rounded-lg"
                            style="cursor: pointer;"
                            @click="showImgPreview(item.choiceImge)"
                          ></v-img>
                        </v-col>
                      </v-radio-group>

                      <v-col
                        v-else
                        v-for="item in item2.choiceList"
                        :key="item.choiceId"
                        cols="auto"
                        class="d-flex flex-column align-center pa-2"
                        style="margin-bottom: 16px;"
                      >
                        <v-checkbox
                          v-model="item.userAnswer"
                          :label="item.choice"
                          hide-details
                          color="#4FB14E"
                          @click="
                            checkCorrectAns(item2.questionId, item.choiceId);
                            item2.ansNotSubmit = false;
                          "
                          class="mb-2"
                        ></v-checkbox>

                        <v-img
                          v-if="item.choiceImge"
                          :src="item.choiceImge"
                          :width="100"
                          :height="80"
                          class="rounded-lg"
                          style="cursor: pointer;"
                          @click="showImgPreview(item.choiceImge)"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
      
             

                </v-row>

                <!-- Answer not submitted -->
                <v-row v-if="item2.ansNotSubmit" class="mt-0">
                  <v-col class="pt-0" style="padding-left: 43px">
                    <v-icon class="mr-2" color="#D52A2A"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span style="font-size: 16px; color: #d52a2a">{{
                      $t("itisnecessarytoanswerquestion")
                    }}</span>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Navigation buttons -->
              <v-row>
                <v-col style="text-align: right; padding-right: 15px">
                  <v-btn
                    v-if="nextQuizSection"
                    @click="clickBack()"
                    class="text-capitalize mr-3"
                    style="
                      color: #424242;
                      background-color: #f0f0f0;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                    >{{ $t("back") }}</v-btn
                  >

                  <!-- F03 DSD — ปุ่มส่งรอโหลดกฎ DSD (UX-F7) -->
                  <v-btn
                    v-if="lastQuizSection"
                    @click="submitQuiz()"
                      :disabled="isSubmitDisabled || dsdRuleLoading"
                    :loading="dsdRuleLoading"
                    class="text-capitalize"
                    style="
                      color: #424242;
                      background-color: #a6cc39;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                  >
                    {{ $t("submit") }}
                  </v-btn>

                  <v-btn
                    v-if="!lastQuizSection"
                    @click="clickNext()"
                    class="text-capitalize"
                    style="
                      color: #424242;
                      background-color: #a6cc39;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                    >{{ $t("next") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <!-- view answer detail -->
      <v-card v-else style="border-radius: 16px; padding: 15px">
        <div v-for="(item1, i) in section_Items" :key="i">
          <v-row>
            <v-col cols="12">
              <span style="font-size: 32px; color: #424242">{{
                item1.sectionName
              }}</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <span style="font-size: 20px; color: #616161">{{
                item1.sectionDescription
              }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11" lg="11">
              <v-card
                v-for="(item2, i) in item1.questionList"
                :key="i"
                style="
                  background-color: #42424208;
                  border-radius: 8px;
                  box-shadow: unset;
                "
                class="mb-7"
              >
                <!--Quiz's Question WhereQuestion(item1.sectionId) -->
                <v-row class="ma-1 ml-0">
                  <v-col
                    cols="11"
                    md="10"
                    lg="10"
                    xl="10"
                    style="
                      padding-right: 30px !important;
                      padding-bottom: 10px;
                      padding-left: 17px;
                    "
                  >
                    <span style="font-size: 20px; color: #424242">{{
                      item2.question
                    }}</span>
                  </v-col>
                  <v-col
                    cols="11"
                    md="2"
                    lg="2"
                    xl="2"
                    style="
                      text-align: right;
                      padding-top: 20px;
                      padding-right: 16px;
                      padding-bottom: 10px;
                    "
                  >
                    <span style="font-size: 16px; color: #616161">{{
                      item2.thisQuesRusult + " / " + item2.questionScore
                    }}</span>
                  </v-col>
                </v-row>
                <v-divider
                  class="ml-4 mr-4"
                  style="border-color: #7070707f"
                ></v-divider>
                <!-- QUESTION included images, that will show here.. -->
                <v-row v-if="item2.questionImge" class="mt-3">
                  <!-- It is Question's image. -->
                  <v-col class="pb-3" lg="5" xl="5">
                    <v-img
                      class="ml-5"
                      :aspect-ratio="15 / 10"
                      :width="445"
                      @click="showImgPreview(item2.questionImge)"
                      v-bind:src="item2.questionImge"
                    ></v-img>
                  </v-col>
                  <!-- It is for if Answers are images conditions -->
                  <v-col class="pb-3" lg="7" xl="7">
                    <v-row
                      v-if="item2.choiceList.some((x) => x.choiceImge != null)"
                    >
                      <v-col
                        cols="11"
                        xs="11"
                        sm="11"
                        md="6"
                        lg="6"
                        xl="6"
                        class="pr-2 pt-2 pb-2"
                        v-for="(item, i) in item2.choiceList"
                        :key="i"
                        style="display: flex; justify-content: flex-start"
                      >
                        <v-card
                          class="mt-4 ml-3"
                          v-if="item.choiceImge"
                          style="
                            border-radius: 16px;
                            padding-left: 8px;
                            box-shadow: unset;
                            padding-top: 10px;
                          "
                          height="169"
                          width="225"
                          :style="[
                            show_CorrectAns1
                              ? show_CorrectAns2
                                ? item.choiceAnswerMaster == true
                                  ? { background: '#A6CC391C' }
                                  : item.userAnswer == true
                                  ? { background: '#FF60601F' }
                                  : { background: 'transparent' }
                                : item.userAnswer != null
                                ? item.userAnswer == true
                                  ? item.choiceAnswerMaster == true
                                    ? { background: '#A6CC391C' }
                                    : { background: '#FF60601F' }
                                  : { background: '#FF60601F' }
                                : { background: 'transparent' }
                              : {},
                          ]"
                        >
                          <v-row>
                            <v-col
                              md="10"
                              style="
                                padding-bottom: 11px !important;
                                padding-right: 0;
                              "
                            >
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-if="
                                  item2.multipleChoice == true &&
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer != null
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>

                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>

                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                v-else-if="item2.multipleChoice == true"
                                v-model="item.userAnswer"
                                :label="item.choice"
                                color="#A4A4A4"
                              ></v-checkbox>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2 || show_CorrectAns1
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  item2.multipleChoice == false &&
                                  item.userAnswer == true &&
                                  item.choiceAnswerMaster == false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.userAnswer == null &&
                                      item.choiceAnswerMaster == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns1 && !show_CorrectAns2
                                    ? item2.multipleChoice == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col md="2" style="padding-left: 0">
                              <!-- showing true or false of user choice -->
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == true
                                "
                                color="#4FB14E"
                                >mdi-check-bold</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == false &&
                                  item.userAnswer == true
                                "
                                color="#FF6060"
                                >mdi-window-close</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-img
                            v-if="item.choiceImge"
                            :key="item.choiceId + 1"
                            class="mb-1 mt-2"
                            :aspect-ratio="14 / 8"
                            :width="205"
                            @click="showImgPreview(item.choiceImge)"
                            :src="item.choiceImge"
                          ></v-img>
                        </v-card>

                        <!-- for text choice mix with image choice -->
                        <v-row
                          v-if="item.choiceImge == null"
                          class="mt-3"
                          style="display: unset"
                        >
                          <v-list-item class="pl-7 mr-2">
                            <v-col
                              md="10"
                              style="
                                border-bottom-left-radius: 8px;
                                border-top-left-radius: 8px;
                                padding: 8px;
                                box-shadow: unset;
                                padding-bottom: 11px !important;
                              "
                              :style="[
                                show_CorrectAns1
                                  ? show_CorrectAns2
                                    ? item.choiceAnswerMaster == true
                                      ? { background: '#A6CC391C' }
                                      : item.userAnswer == true
                                      ? { background: '#FF60601F' }
                                      : { background: 'transparent' }
                                    : item.userAnswer != null
                                    ? item.userAnswer == true
                                      ? item.choiceAnswerMaster == true
                                        ? { background: '#A6CC391C' }
                                        : { background: '#FF60601F' }
                                      : { background: '#FF60601F' }
                                    : { background: 'transparent' }
                                  : {},
                              ]"
                            >
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-if="
                                  item2.multipleChoice == true &&
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer != null
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                v-else-if="item2.multipleChoice == true"
                                v-model="item.userAnswer"
                                :label="item.choice"
                                color="#A4A4A4"
                              ></v-checkbox>
                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2 || show_CorrectAns1
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  item2.multipleChoice == false &&
                                  item.userAnswer == true &&
                                  item.choiceAnswerMaster == false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.userAnswer == null &&
                                      item.choiceAnswerMaster == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns1 && !show_CorrectAns2
                                    ? item2.multipleChoice == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              md="2"
                              style="
                                border-bottom-right-radius: 8px;
                                border-top-right-radius: 8px;
                                padding: 8px;
                                box-shadow: unset;
                                padding-left: 0;
                                padding-bottom: 11px !important;
                              "
                              :style="[
                                show_CorrectAns1
                                  ? show_CorrectAns2
                                    ? item.choiceAnswerMaster == true
                                      ? { background: '#A6CC391C' }
                                      : item.userAnswer == true
                                      ? { background: '#FF60601F' }
                                      : { background: 'transparent' }
                                    : item.userAnswer != null
                                    ? item.userAnswer == true
                                      ? item.choiceAnswerMaster == true
                                        ? { background: '#A6CC391C' }
                                        : { background: '#FF60601F' }
                                      : { background: '#FF60601F' }
                                    : { background: 'transparent' }
                                  : {},
                              ]"
                            >
                              <!-- showing true or false of user choice -->
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == true
                                "
                                color="#4FB14E"
                                >mdi-check-bold</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == false &&
                                  item.userAnswer == true
                                "
                                color="#FF6060"
                                >mdi-window-close</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == null
                                "
                                color="transparent"
                                >mdi-window-close</v-icon
                              >
                            </v-col>
                          </v-list-item>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- It is for if Answers are pure text -->
                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    v-if="!item2.choiceList.some((x) => x.choiceImge != null)"
                  >
                    <v-row class="pl-4 pb-2 pr-4">
                      <v-col class="pt-1 pb-0">
                        <v-list style="background: transparent">
                          <!-- Answer Choice List. Choose the correct choice... -->
                          <v-list-item-group multiple class="option_sheet">
                            <!-- WhereChoice(item.questionId) , i -->
                            <template v-for="item in item2.choiceList">
                              <!--  -->
                              <v-list-item
                                disabled
                                class="viewans_"
                                v-if="item"
                                :key="item.choiceId"
                                style="
                                  border-radius: 8px;
                                  height: 32px;
                                  margin-bottom: 10px;
                                "
                                :style="[
                                  show_CorrectAns1
                                    ? show_CorrectAns2
                                      ? item.choiceAnswerMaster == true
                                        ? { background: '#A6CC391C' }
                                        : item.userAnswer == true
                                        ? { background: '#FF60601F' }
                                        : { background: 'transparent' }
                                      : item.userAnswer != null
                                      ? item.userAnswer == true
                                        ? item.choiceAnswerMaster == true
                                          ? { background: '#A6CC391C' }
                                          : { background: '#FF60601F' }
                                        : { background: '#FF60601F' }
                                      : { background: 'transparent' }
                                    : {},
                                ]"
                              >
                                <v-list-item-action>
                                  <v-checkbox
                                    disabled
                                    class="disable_green"
                                    v-if="
                                      item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer != null
                                    "
                                    v-model="item.choiceAnswerMaster"
                                    color="#4FB14E"
                                  ></v-checkbox>
                                  <v-checkbox
                                    disabled
                                    class="disable_green"
                                    v-model="item.choiceAnswerMaster"
                                    v-else-if="
                                      show_CorrectAns2
                                        ? item2.multipleChoice == true &&
                                          item.choiceAnswerMaster == true &&
                                          item.userAnswer == null
                                          ? true
                                          : false
                                        : false
                                    "
                                    color="#4FB14E"
                                  ></v-checkbox>
                                  <v-checkbox
                                    disabled
                                    class="disable_grey"
                                    v-else-if="item2.multipleChoice == true"
                                    v-model="item.userAnswer"
                                    color="#A4A4A4"
                                  ></v-checkbox>
                                  <v-radio-group
                                    disabled
                                    v-if="
                                      show_CorrectAns2
                                        ? item2.multipleChoice == false &&
                                          item.choiceAnswerMaster == true &&
                                          item.userAnswer == null
                                          ? true
                                          : false
                                        : false
                                    "
                                    hide-details
                                    class="mt-0 pt-0 disable_radio_green"
                                    v-model="item2.radio_masterChoice"
                                  >
                                    <v-radio
                                      @click="
                                        checkCorrectAns(
                                          item2.questionId,
                                          item.choiceId
                                        ),
                                          (item.userAnswer = true)
                                      "
                                      :value="item.choiceId"
                                      color="#4FB14E"
                                    ></v-radio>
                                  </v-radio-group>

                                  <v-radio-group
                                    disabled
                                    v-if="
                                      show_CorrectAns2 || show_CorrectAns1
                                        ? item2.multipleChoice == false &&
                                          item.choiceAnswerMaster == true &&
                                          item.userAnswer == true
                                          ? true
                                          : false
                                        : false
                                    "
                                    hide-details
                                    class="mt-0 pt-0 disable_radio_green"
                                    v-model="item2.radio_masterChoice"
                                  >
                                    <v-radio
                                      @click="
                                        checkCorrectAns(
                                          item2.questionId,
                                          item.choiceId
                                        ),
                                          (item.userAnswer = true)
                                      "
                                      :value="item.choiceId"
                                      color="#4FB14E"
                                    ></v-radio>
                                  </v-radio-group>

                                  <v-radio-group
                                    disabled
                                    v-if="
                                      item2.multipleChoice == false &&
                                      item.userAnswer == true &&
                                      item.choiceAnswerMaster == false
                                    "
                                    hide-details
                                    class="mt-0 pt-0 disable_radio_grey"
                                    v-model="item2.radio_UserChoice"
                                  >
                                    <v-radio
                                      @click="
                                        checkCorrectAns(
                                          item2.questionId,
                                          item.choiceId
                                        ),
                                          (item.userAnswer = true)
                                      "
                                      :value="item.choiceId"
                                      color="#4FB14E"
                                    ></v-radio>
                                  </v-radio-group>

                                  <v-radio-group
                                    disabled
                                    v-else-if="
                                      show_CorrectAns2
                                        ? item2.multipleChoice == false &&
                                          item.userAnswer == null &&
                                          item.choiceAnswerMaster == false
                                          ? true
                                          : false
                                        : false
                                    "
                                    hide-details
                                    class="mt-0 pt-0 disable_radio_grey"
                                    v-model="item2.radio_UserChoice"
                                  >
                                    <v-radio
                                      @click="
                                        checkCorrectAns(
                                          item2.questionId,
                                          item.choiceId
                                        ),
                                          (item.userAnswer = true)
                                      "
                                      :value="item.choiceId"
                                      color="#4FB14E"
                                    ></v-radio>
                                  </v-radio-group>

                                  <v-radio-group
                                    disabled
                                    v-else-if="
                                      show_CorrectAns1 && !show_CorrectAns2
                                        ? item2.multipleChoice == false &&
                                          item.userAnswer == null
                                          ? true
                                          : false
                                        : false
                                    "
                                    hide-details
                                    class="mt-0 pt-0 disable_radio_grey"
                                    v-model="item2.radio_UserChoice"
                                  >
                                    <v-radio
                                      @click="
                                        checkCorrectAns(
                                          item2.questionId,
                                          item.choiceId
                                        ),
                                          (item.userAnswer = true)
                                      "
                                      :value="item.choiceId"
                                      color="#4FB14E"
                                    ></v-radio>
                                  </v-radio-group>
                                  <!-- radio bug -->
                                </v-list-item-action>

                                <v-list-item-content
                                  v-if="item"
                                  style="padding-right: 26px"
                                >
                                  <span
                                    style="font-size: 16px; color: #424242"
                                    >{{ item.choice }}</span
                                  >
                                  <v-img
                                    v-if="item.choiceImge"
                                    :key="item.choiceId + 1"
                                    class="mb-3"
                                    :aspect-ratio="16 / 9"
                                    :width="170"
                                    @click="showImgPreview(item.choiceImge)"
                                    v-bind:src="item.choiceImge"
                                  ></v-img>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-icon
                                    v-if="
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                    "
                                    color="#4FB14E"
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="
                                      item.choiceAnswerMaster == false &&
                                      item.userAnswer == true
                                    "
                                    color="#FF6060"
                                    >mdi-window-close</v-icon
                                  >
                                </v-list-item-action>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <!--QUESTION does not include images => Both master & user answers-->
                <v-row v-else class="ma-1">
                  <!-- It is for if Answers are text -->
                  <v-col
                    v-if="!item2.choiceList.some((x) => x.choiceImge != null)"
                    class="pt-1 pb-3"
                  >
                    <v-list style="background: transparent">
                      <!-- Answer Choice List. Choose the correct choice... -->
                      <v-list-item-group multiple class="option_sheet">
                        <!-- WhereChoice(item.questionId) , i -->
                        <template v-for="item in item2.choiceList">
                          <!--  -->
                          <v-list-item
                            disabled
                            class="viewans_"
                            v-if="item"
                            :key="item.choiceId"
                            style="
                              border-radius: 8px;
                              height: 32px;
                              margin-bottom: 10px;
                            "
                            :style="[
                              show_CorrectAns1
                                ? show_CorrectAns2
                                  ? item.choiceAnswerMaster == true
                                    ? { background: '#A6CC391C' }
                                    : item.userAnswer == true
                                    ? { background: '#FF60601F' }
                                    : { background: 'transparent' }
                                  : item.userAnswer != null
                                  ? item.userAnswer == true
                                    ? item.choiceAnswerMaster == true
                                      ? { background: '#A6CC391C' }
                                      : { background: '#FF60601F' }
                                    : { background: '#FF60601F' }
                                  : { background: 'transparent' }
                                : {},
                            ]"
                          >
                            <v-list-item-action>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-if="
                                  item2.multipleChoice == true &&
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer != null
                                "
                                v-model="item.choiceAnswerMaster"
                                color="#4FB14E"
                              ></v-checkbox>

                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                v-model="item.choiceAnswerMaster"
                                color="#4FB14E"
                              ></v-checkbox>

                              <v-checkbox
                                disabled
                                class="disable_grey"
                                v-else-if="item2.multipleChoice == true"
                                v-model="item.userAnswer"
                                color="#A4A4A4"
                              ></v-checkbox>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2 || show_CorrectAns1
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  item2.multipleChoice == false &&
                                  item.userAnswer == true &&
                                  item.choiceAnswerMaster == false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.userAnswer == null &&
                                      item.choiceAnswerMaster == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns1 && !show_CorrectAns2
                                    ? item2.multipleChoice == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-list-item-action>

                            <v-list-item-content
                              v-if="item"
                              style="padding-right: 26px"
                            >
                              <span style="font-size: 16px; color: #424242">{{
                                item.choice
                              }}</span>
                              <v-img
                                v-if="item.choiceImge"
                                :key="item.choiceId + 1"
                                class="mb-3"
                                :aspect-ratio="16 / 9"
                                :width="170"
                                @click="showImgPreview(item.choiceImge)"
                                v-bind:src="item.choiceImge"
                              ></v-img>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == true
                                "
                                color="#4FB14E"
                                >mdi-check-bold</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == false &&
                                  item.userAnswer == true
                                "
                                color="#FF6060"
                                >mdi-window-close</v-icon
                              >
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <!-- It is for if Answers are images -->
                  <v-col v-else class="pb-4 pt-1">
                    <v-row>
                      <v-col
                        cols="11"
                        xs="11"
                        sm="11"
                        md="6"
                        lg="6"
                        xl="6"
                        class="pr-2 pt-2 pb-2"
                        v-for="(item, i) in item2.choiceList"
                        :key="i"
                        style="display: flex; justify-content: flex-start"
                      >
                        <v-card
                          class="mt-4 ml-3"
                          v-if="item.choiceImge"
                          style="
                            border-radius: 16px;
                            padding-left: 8px;
                            box-shadow: unset;
                            padding-top: 10px;
                          "
                          height="169"
                          width="225"
                          :style="[
                            show_CorrectAns1
                              ? show_CorrectAns2
                                ? item.choiceAnswerMaster == true
                                  ? { background: '#A6CC391C' }
                                  : item.userAnswer == true
                                  ? { background: '#FF60601F' }
                                  : { background: 'transparent' }
                                : item.userAnswer != null
                                ? item.userAnswer == true
                                  ? item.choiceAnswerMaster == true
                                    ? { background: '#A6CC391C' }
                                    : { background: '#FF60601F' }
                                  : { background: '#FF60601F' }
                                : { background: 'transparent' }
                              : {},
                          ]"
                        >
                          <v-row>
                            <v-col
                              md="10"
                              style="
                                padding-bottom: 11px !important;
                                padding-right: 0;
                              "
                            >
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-if="
                                  item2.multipleChoice == true &&
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer != null
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>

                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                :label="item.choice"
                                v-model="item.choiceAnswerMaster"
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                v-else-if="item2.multipleChoice == true"
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#A4A4A4"
                              ></v-checkbox>
                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2 || show_CorrectAns1
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  item2.multipleChoice == false &&
                                  item.userAnswer == true &&
                                  item.choiceAnswerMaster == false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.userAnswer == null &&
                                      item.choiceAnswerMaster == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns1 && !show_CorrectAns2
                                    ? item2.multipleChoice == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col md="2" style="padding-left: 0">
                              <!-- showing true or false of user choice -->
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == true
                                "
                                color="#4FB14E"
                                >mdi-check-bold</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == false &&
                                  item.userAnswer == true
                                "
                                color="#FF6060"
                                >mdi-window-close</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-img
                            v-if="item.choiceImge"
                            :key="item.choiceId + 1"
                            class="mb-1 mt-2"
                            :aspect-ratio="14 / 8"
                            :width="205"
                            @click="showImgPreview(item.choiceImge)"
                            :src="item.choiceImge"
                          ></v-img>
                        </v-card>

                        <!-- for text choice mix with image choice -->
                        <v-row
                          v-if="item.choiceImge == null"
                          class="mt-3"
                          style="display: unset"
                        >
                          <v-list-item class="pl-7 mr-2">
                            <v-col
                              md="10"
                              style="
                                border-bottom-left-radius: 8px;
                                border-top-left-radius: 8px;
                                padding: 8px;
                                box-shadow: unset;
                                padding-bottom: 11px !important;
                              "
                              :style="[
                                show_CorrectAns1
                                  ? show_CorrectAns2
                                    ? item.choiceAnswerMaster == true
                                      ? { background: '#A6CC391C' }
                                      : item.userAnswer == true
                                      ? { background: '#FF60601F' }
                                      : { background: 'transparent' }
                                    : item.userAnswer != null
                                    ? item.userAnswer == true
                                      ? item.choiceAnswerMaster == true
                                        ? { background: '#A6CC391C' }
                                        : { background: '#FF60601F' }
                                      : { background: '#FF60601F' }
                                    : { background: 'transparent' }
                                  : {},
                              ]"
                            >
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_green mt-0"
                                v-if="
                                  item2.multipleChoice == true &&
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer != null
                                "
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                :label="item.choice"
                                v-model="item.choiceAnswerMaster"
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == true &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                color="#4FB14E"
                              ></v-checkbox>
                              <v-checkbox
                                disabled
                                hide-details
                                class="disable_grey mt-0"
                                v-else-if="item2.multipleChoice == true"
                                v-model="item.choiceAnswerMaster"
                                :label="item.choice"
                                color="#A4A4A4"
                              ></v-checkbox>
                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == null
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-if="
                                  show_CorrectAns2 || show_CorrectAns1
                                    ? item2.multipleChoice == false &&
                                      item.choiceAnswerMaster == true &&
                                      item.userAnswer == true
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_green"
                                v-model="item2.radio_masterChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  item2.multipleChoice == false &&
                                  item.userAnswer == true &&
                                  item.choiceAnswerMaster == false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_UserChoice"
                              >
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns2
                                    ? item2.multipleChoice == false &&
                                      item.userAnswer == null &&
                                      item.choiceAnswerMaster == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_masterChoice"
                              >
                                <!-- radio_UserChoice -->
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>

                              <v-radio-group
                                disabled
                                v-else-if="
                                  show_CorrectAns1 && !show_CorrectAns2
                                    ? item2.multipleChoice == false
                                      ? true
                                      : false
                                    : false
                                "
                                hide-details
                                class="mt-0 pt-0 disable_radio_grey"
                                v-model="item2.radio_masterChoice"
                              >
                                <!-- radio_UserChoice -->
                                <v-radio
                                  @click="
                                    checkCorrectAns(
                                      item2.questionId,
                                      item.choiceId
                                    ),
                                      (item.userAnswer = true)
                                  "
                                  :value="item.choiceId"
                                  :label="item.choice"
                                  color="#4FB14E"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              md="2"
                              style="
                                border-bottom-right-radius: 8px;
                                border-top-right-radius: 8px;
                                padding: 8px;
                                box-shadow: unset;
                                padding-left: 0;
                                padding-bottom: 11px !important;
                              "
                              :style="[
                                show_CorrectAns1
                                  ? show_CorrectAns2
                                    ? item.choiceAnswerMaster == true
                                      ? { background: '#A6CC391C' }
                                      : item.userAnswer == true
                                      ? { background: '#FF60601F' }
                                      : { background: 'transparent' }
                                    : item.userAnswer != null
                                    ? item.userAnswer == true
                                      ? item.choiceAnswerMaster == true
                                        ? { background: '#A6CC391C' }
                                        : { background: '#FF60601F' }
                                      : { background: '#FF60601F' }
                                    : { background: 'transparent' }
                                  : {},
                              ]"
                            >
                              <!-- showing true or false of user choice -->
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == true
                                "
                                color="#4FB14E"
                                >mdi-check-bold</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == false &&
                                  item.userAnswer == true
                                "
                                color="#FF6060"
                                >mdi-window-close</v-icon
                              >
                              <v-icon
                                v-if="
                                  item.choiceAnswerMaster == true &&
                                  item.userAnswer == null
                                "
                                color="transparent"
                                >mdi-window-close</v-icon
                              >
                            </v-col>
                          </v-list-item>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
              <v-row>
                <v-col style="text-align: right; padding-right: 15px">
                  <v-btn
                    v-if="nextQuizSection"
                    @click="clickBack()"
                    class="text-capitalize mr-3"
                    style="
                      color: #424242;
                      background-color: #f0f0f0;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                    >{{ $t("back") }}</v-btn
                  >
                  <v-btn
                    v-if="lastQuizSection"
                    @click="clickFinished()"
                    class="text-capitalize"
                    style="
                      color: #424242;
                      background-color: #a6cc39;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                    >{{ $t("qfinished") }}</v-btn
                  >
                  <v-btn
                    v-if="!lastQuizSection"
                    @click="clickNextForAnswerCheck()"
                    class="text-capitalize"
                    style="
                      color: #424242;
                      background-color: #a6cc39;
                      font-size: 16px;
                      border-radius: 8px;
                      box-shadow: unset;
                    "
                    >{{ $t("next") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>

    <v-dialog width="450" v-model="resultDialog" persistent>
      <v-card style="border-radius: 16px">
        <!-- F03 DSD — ทาง DSD มีหัว "ผลลัพธ์" + ปุ่ม X เสมอ (UX-F5b) -->
        <v-card-title
          v-if="show_CorrectAns1 || show_score || showPassingScore || dsdResult"
          class="pt-2 pb-1"
        >
          <v-row v-if="show_score || !passQuiz || dsdResult" justify="center" no-gutters>
            <v-col>
              <span
                style="font-size: 20px; color: #363636; font-weight: bold"
                >{{ $t("result") }}</span
              >
            </v-col>
            <v-col style="text-align: right">
              <!-- F03 DSD — ปุ่ม X ของทาง DSD เรียก goBack() (template ห้าม globalThis) UX-F6 -->
              <v-btn
                v-if="dsdResult"
                :aria-label="$t('close')"
                @click="resultDialog = false; goBack()"
                style="
                  border-radius: 8px !important;
                  border: 1px solid rgba(66, 66, 66, 0.05);
                  background-color: transparent;
                  color: #424242;
                  box-shadow: unset;
                  width: 23px;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn
                v-else
                @click="(resultDialog = false), globalThis.messageHandler.postMessage('GoBack')"
                style="
                  border-radius: 8px !important;
                  border: 1px solid rgba(66, 66, 66, 0.05);
                  background-color: transparent;
                  color: #424242;
                  box-shadow: unset;
                  width: 23px;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-else justify="center" no-gutters>
            <v-col style="text-align: center" class="pt-1 pb-1">
              <span class="mt-2" style="font-size: 20px; color: #363636">{{
                $t("thankyoufordoingquiz")
              }}</span>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-title v-else>
          <v-row justify="center" no-gutters>
            <v-col style="text-align: center" class="pt-1 pb-1">
              <span class="mt-2" style="font-size: 20px; color: #363636">{{
                $t("thankyoufordoingquiz")
              }}</span>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <!-- F03 DSD — กล่องผลลัพธ์ DSD (UX-F5, F5a) แสดงเสมอไม่ขึ้นกับ showScore/showPassingScore -->
        <v-card-text v-if="dsdResult" class="pb-1 pt-3 text-center text-break">
          <p v-if="dsdTimeUp" data-testid="dsd-result-timeup" class="mb-2" style="font-size: 14px; color: #ff6060">
            <v-icon small color="#FF6060">mdi-timer-off-outline</v-icon>
            {{ $t("quiztimeupsubmitted") }}
          </p>
          <v-chip
            label
            data-testid="dsd-result-status"
            class="font-weight-bold"
            style="font-size: 18px"
            :color="dsdStatusChip.color"
            :text-color="dsdStatusChip.textColor"
          >
            <v-icon left>{{ dsdStatusChip.icon }}</v-icon>{{ $t(dsdStatusChip.labelKey) }}
          </v-chip>
          <p data-testid="dsd-result-score" class="mt-3 mb-1 font-weight-bold" style="font-size: 48px; line-height: 1.2; color: #424242">
            {{ dsdScoreText }}
          </p>
          <p data-testid="dsd-result-percent" class="mb-1" style="font-size: 18px; color: #424242">
            {{ $t("quizscorepercent", [dsdScorePercentText]) }}
          </p>
          <p data-testid="dsd-result-criteria" class="mb-1" style="font-size: 16px; color: #616161">
            {{ $t("quizpassingcriteria", [dsdPassingScoreText, dsdPassingPercentText]) }}
          </p>
          <p v-if="dsdPendingCount > 0" data-testid="dsd-result-pending" class="mb-1 orange--text text--darken-4" style="font-size: 14px">
            {{ $t("quizpendingreview", [dsdPendingCountText]) }}
          </p>
          <p v-if="dsdIsPretest" data-testid="dsd-result-pretest-note" class="mb-1" style="font-size: 14px; color: #616161">
            <v-icon small color="#616161">mdi-information-outline</v-icon>
            {{ $t("quizpretestnote") }}
          </p>
        </v-card-text>
        <v-card-text v-else-if="show_score || !passQuiz" class="pb-1 pt-2">
          <p
            v-if="showRetryPrompt"
            class="pt-1 text-left mb-0"
            style="font-size: 18px; color: #424242"
          >
            {{ $t("notpassquiz") }}
          </p>
          <!-- TC-LMS-018: Pre-test ไม่ผ่านไม่ชวนทำซ้ำ -->
          <p
            v-else-if="isPretestResult && !passQuiz"
            data-testid="quiz-pretest-note"
            class="pt-1 text-left mb-0"
            style="font-size: 16px; color: #616161"
          >
            {{ $t("quizpretestnote") }}
          </p>
          <p
            v-if="show_score && passQuiz"
            class="pt-1 mb-0 text-left"
            style="font-size: 16px; color: #424242"
          >
            {{ $t("thankyoufordoingquiz") }}
          </p>
          <p
            v-if="show_score"
            class="pt-1 text-left"
            style="font-size: 16px; color: #424242"
          >
            {{ $t("scoresyouhaveearned") }}
          </p>
          <!-- && passQuiz -->
          <p
            v-if="show_score"
            class="pt-4 text-center mt-7"
            style="font-size: 56px"
            :style="[passQuiz ? { color: '#4FB14E' } : { color: '#FF6060' }]"
          >
            {{ user_score + "/" + full_score }}
          </p>
          <p
            v-if="showPassingScore"
            class="pt-4 text-center"
            style="font-size: 20px; color: #616161"
          >
            {{ $t("passingscore") + passing_score }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-row justify="center" no-gutters>
            <v-btn
              v-if="showRetryPrompt"
              color="#FF6060"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset"
              class="text-capitalize white--text mt-1 mb-2"
              @click="doQuizAgain()"
              >{{ $t("requiz") }}</v-btn
            >
            <!-- TC-LMS-018: Pre-test ไม่ผ่าน → ปุ่ม "ปิด" กลับแอป (ไม่ใช่ "ทำแบบทดสอบอีกครั้ง") -->
            <v-btn
              v-else-if="!passQuiz && $route.query.quizIsPassed == 0"
              color="#4FB14E"
              data-testid="quiz-pretest-close"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset"
              class="text-capitalize white--text mt-1 mb-2"
              @click="Click_ok()"
              >{{ $t("close") }}</v-btn
            >
            <v-btn
              v-else-if="show_CorrectAns1 && !notTakeQuizAndSubmit"
              color="#A6CC39"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset; color: #424242"
              class="text-capitalize mt-1 mb-2"
              @click="viewAnswerResult()"
              >{{ $t("viewanswer") }}</v-btn
            >
            <v-btn
              v-else
              color="#4FB14E"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset"
              class="text-capitalize white--text mt-1 mb-1"
              @click="Click_ok()"
              >{{ $t("ok") }}</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="#4FB14E" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#ffffff"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="350" v-model="timerDialog" persistent>
      <v-card style="border-radius: 16px">
        <v-card-title class="pt-2 pb-1 pr-3">
          <v-row justify="center" no-gutters>
            <v-col>
              <span
                style="font-size: 20px; color: #363636; font-weight: bold"
                >{{ $t("result") }}</span
              >
            </v-col>
            <v-col style="text-align: right">
              <v-btn
                @click="(timerDialog = false), clickFinished()"
                style="
                  border-radius: 8px !important;
                  border: 1px solid rgba(66, 66, 66, 0.05);
                  background-color: transparent;
                  color: #424242;
                  box-shadow: unset;
                  width: 23px;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pb-1 pt-2">
          <p
            v-if="!finishQuizOnTime"
            class="pt-3 text-left"
            style="font-size: 32px; color: #ff6060; font-weight: bolder"
          >
            {{ $t("timesup") }}
          </p>
          <!-- ......................... -->
          <p
            v-if="finishQuizOnTime"
            class="pt-3 text-left"
            style="font-size: 30px; font-weight: bolder"
            :style="notTakeQuizAndSubmit ? 'color: #ff6060;' : 'color: #4fb050'"
          >
            {{
              !notTakeQuizAndSubmit
                ? $t("congratulation")
                : $t("submit-empty-ans")
            }}
          </p>
          <!-- ......................... -->
          <p
            v-if="!finishQuizOnTime"
            class="pt-3 text-left"
            style="font-size: 18px; color: #424242"
          >
            {{ $t("notcompletewithinthetime") }}
          </p>

          <p
            v-if="!finishQuizOnTime"
            class="pt-3"
            style="font-size: 18px; color: #616161"
          >
            {{ $t("youanswerquestion").replace("{0}", answeredQuo) }}
          </p>
          <!-- .............. -->
          <p
            v-if="finishQuizOnTime"
            class="pt-3"
            style="font-size: 18px; color: #616161"
          >
            {{
              !notTakeQuizAndSubmit
                ? $t("youcompletequizinminutes").replace(
                    "{0}",
                    formatTime(elapsedTime)
                  )
                : $t("youanswerquestion").replace("{0}", answeredQuo)
            }}
          </p>
          <!-- .................... -->
        </v-card-text>

        <v-card-actions>
          <v-row justify="center" no-gutters>
            <v-btn
              color="#A6CC39"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset; color: #424242"
              class="text-capitalize mt-5 mb-2"
              @click="gotoResultDialog()"
              >{{ $t("next") }}</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- F03 DSD — ส่งคำตอบไม่สำเร็จ (UX-F9) ไม่แสดงผลปลอม -->
    <v-dialog width="350" v-model="dsdSubmitErrorDialog" persistent>
      <v-card style="border-radius: 16px" data-testid="dsd-submit-error">
        <v-card-text class="pt-6 pb-1 text-center">
          <v-icon color="#FF6060" size="40">mdi-alert-circle-outline</v-icon>
          <p class="text-break mt-3 mb-0" style="font-size: 18px; color: #424242">
            {{ dsdSubmitErrorKey ? $t(dsdSubmitErrorKey) : "" }}
          </p>
        </v-card-text>
        <v-card-actions class="pb-4">
          <!-- F03 DSD — จอ xs ปุ่มเต็มความกว้างเรียงแนวตั้ง (TC-34) -->
          <v-row justify="center" no-gutters :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }">
            <v-btn
              v-if="dsdSubmitRetryable"
              color="#A6CC39"
              :block="$vuetify.breakpoint.xsOnly"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset; color: #424242"
              class="text-capitalize mt-3"
              :class="{ 'mx-1': !$vuetify.breakpoint.xsOnly }"
              :style="$vuetify.breakpoint.xsOnly ? 'min-width: 100%' : ''"
              @click="dsdSubmitRetry()"
              >{{ $t("quizsubmitretry") }}</v-btn
            >
            <v-btn
              v-if="dsdSubmitRetryable"
              text
              :block="$vuetify.breakpoint.xsOnly"
              style="font-size: 16px; color: #424242"
              class="text-capitalize mt-3"
              :class="{ 'mx-1': !$vuetify.breakpoint.xsOnly }"
              :style="$vuetify.breakpoint.xsOnly ? 'min-width: 100%' : ''"
              @click="dsdSubmitExit()"
              >{{ $t("quizexit") }}</v-btn
            >
            <v-btn
              v-if="!dsdSubmitRetryable"
              color="#A6CC39"
              :block="$vuetify.breakpoint.xsOnly"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset; color: #424242"
              class="text-capitalize mt-3"
              :style="$vuetify.breakpoint.xsOnly ? 'min-width: 100%' : ''"
              @click="dsdSubmitExit()"
              >{{ $t("ok") }}</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog for submitting without answering all question -->
    <v-dialog width="350" v-model="incompleteSubmitDialog" persistent>
      <v-card style="border-radius: 16px">
        <v-card-title class="pt-2 pb-1 pr-3">
          <v-row justify="center" no-gutters>
            <v-col>
              <span
                style="font-size: 20px; color: #363636; font-weight: bold"
                >{{ $t("result") }}</span
              >
            </v-col>
            <v-col style="text-align: right">
              <v-btn
                @click="
                  (incompleteSubmitDialog = false), clickFinished()
                "
                style="
                  border-radius: 8px !important;
                  border: 1px solid rgba(66, 66, 66, 0.05);
                  background-color: transparent;
                  color: #424242;
                  box-shadow: unset;
                  width: 23px;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-1 pt-2">
          <p
            class="pt-3 text-left"
            style="font-size: 30px; color: #ff6060; font-weight: bolder"
          >
            {{ $t("submit-incomplete-ans") }}
          </p>
          <p class="pt-3" style="font-size: 18px; color: #616161">
            {{ $t("youanswerquestion").replace("{0}", answeredQuo) }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" no-gutters>
            <v-btn
              color="#A6CC39"
              style="font-size: 16px; border-radius: 8px; box-shadow: unset; color: #424242"
              class="text-capitalize mt-5 mb-2"
              @click="gotoResultDialog()"
              >{{ $t("next") }}</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="800px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          style="border-radius: 8px; margin: auto"
          :src="picturePreview"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      // Dialogs
      incompleteSubmitDialog: false,
      notTakeQuizAndSubmit: false,
      timerDialog: false,
      resultDialog: false,

      // Timer
      initialTime: 0,
      elapsedTime: 0,
      remainingTime: 0,
      timer: 0,
      hasTimer: false,
      finishQuizOnTime: true,

      // Quiz settings
      show_CorrectAns1: false, // highlight only user's answer
      show_CorrectAns2: false, // highlight after completion
      showPassingScore: false,
      show_score: false,

      // Image preview
      previewimg: false,
      picturePreview: null,

      // Quiz results
      user_score: 0,
      full_score: 0,
      passing_score: 0,
      passQuiz: true,
      resultTitle: "",
      viewAnswer: false,

      // Navigation
      lastQuizSection: false,
      nextQuizSection: false,

      // Quiz data
      quizSectionData: [], // all section/question data
      quiz_Data: {
        sectionList: [], // reactive, will contain sections with questionList
      },
      QuizID: 0,
      dateoffset: new Date().getTimezoneOffset(),

      // Items
      section_Items: [],
      question_Items: [],
      choice_Items: [
        {
          show_imgBtn: false, // show image in each row
          choiceNo: 1,
          choice: "Option",
          choiceImge: null,
          choiceAnswerMaster: null,
          userAnswer: false, // important for reactivity
          rule: false,
        },
      ],

      // ✅ Subjective support
      // EssayAnswer: false,
      // AIChecking: false,
      // CorrectAnswer: "",

      // SubjectiveFlag: false,
      // UserEssayAnswer: "",

      // Other helpers
      answeredQuo: "",
      loading: false,
      // F03 DSD — สถานะโหมด DSD (กฎจาก v7 GetQuizAssessmentRule, ผลจาก v7 SubmitUserQuiz)
      dsdRule: null,
      dsdResult: null,
      dsdTimeUp: false,
      dsdRuleLoading: false,
      dsdSubmitErrorDialog: false,
      dsdSubmitErrorKey: "",
      dsdSubmitRetryable: false,
    };
  },
  mounted() {
     const selectedLang = this.$route.query.lang || 'en'; 
    if(selectedLang === 'vi'){
      this.$i18n.locale = 'vn';
    }
    else{
      this.$i18n.locale = selectedLang;
    }
    this.GetQuizMasterDetail();
  },

 computed: {
  isSubmitDisabled() {
    if (!this.quizSectionData || this.quizSectionData.length === 0) return true;

    for (const section of this.quizSectionData) {
      for (const question of section.questionList) {
        if (this.isQuestionUnanswered(question)) return true;
      }
    }

    return false;
  },
    // F03 DSD — computed กัน null สำหรับ template (ห้าม ?. ใน template)
    isDsdMode() {
      return !!(this.dsdRule && this.dsdRule.dsdMode === true);
    },
    dsdStatusChip() {
      const s = this.dsdResult ? this.dsdResult.resultStatus : "";
      if (s === "PASSED")
        return { color: "green lighten-5", textColor: "green darken-3", icon: "mdi-check-circle", labelKey: "pass" };
      if (s === "PENDING_REVIEW")
        return { color: "orange lighten-5", textColor: "orange darken-4", icon: "mdi-clock-outline", labelKey: "quizresultpending" };
      return { color: "red lighten-5", textColor: "red darken-3", icon: "mdi-close-circle", labelKey: "fail" };
    },
    dsdScoreText() {
      return this.dsdResult ? this.dsdResult.totalScore + "/" + this.dsdResult.fullScore : "";
    },
    dsdScorePercentText() {
      // API ตัดทิ้งแล้ว (DsdQuizRule.Percent) → แสดง 2 ตำแหน่ง
      return this.dsdResult ? Number(this.dsdResult.scorePercent || 0).toFixed(2) : "";
    },
    dsdPassingScoreText() {
      return this.dsdResult ? String(this.dsdResult.passingScore || 0) : "";
    },
    dsdPassingPercentText() {
      return this.dsdResult ? Number(this.dsdResult.passingPercent || 0).toFixed(2) : "";
    },
    dsdPendingCount() {
      return this.dsdResult && this.dsdResult.pendingReviewCount > 0 ? this.dsdResult.pendingReviewCount : 0;
    },
    dsdPendingCountText() {
      return String(this.dsdPendingCount);
    },
    dsdIsPretest() {
      // quizType จาก response (1 PostTest, 2 PreTest — docs/domain-codes.md)
      return !!(this.dsdResult && Number(this.dsdResult.quizType) === 2);
    },
    // TC-LMS-018 — คอร์ส DSD ใช้ quizType จาก response, คอร์สทั่วไปใช้ quizType ที่แอปส่งมาใน query (2 = PreTest)
    // (แอปรุ่นเก่าส่ง quizTypeID — รับทั้งสองชื่อ)
    isPretestResult() {
      if (this.dsdResult) return this.dsdIsPretest;
      const q = this.$route.query;
      return Number(q.quizType != null ? q.quizType : q.quizTypeID) === 2;
    },
    showRetryPrompt() {
      return !this.passQuiz && this.$route.query.quizIsPassed == 0 && !this.isPretestResult;
    },
}
,
  methods: {
    isQuestionUnanswered(question) {
      if (question.subjectiveFlag) {
        return (
          !question.userEssayAnswer ||
          question.userEssayAnswer.trim() === ""
        );
      }
      return !question.choiceList.some((choice) => choice.userAnswer === true);
    },
    onRadioChange(question) {
      
      question.choiceList.forEach((c) => (c.userAnswer = false));
     
      const selected = question.choiceList.find(
        (c) => c.choiceId === question.radio_UserChoice
      );
      if (selected) selected.userAnswer = true;

     
      console.log(
        "radio change:",
        question.radio_UserChoice,
        question.choiceList
      );
    },

    gotoResultDialog() {
      this.resultDialog = true;
      this.timerDialog = false;
      this.incompleteSubmitDialog = false;
    },

    startTimer() {
      if (this.remainingTime !== 0) {
        this.timer = setInterval(() => {
          if (this.remainingTime > 0) {
            this.remainingTime--;
          } else {
            this.stopTimer(); 
            this.onTimeUp(); 
          }
        }, 1000); 
      }
    },

    // Stop the timer
    stopTimer() {
      clearInterval(this.timer);
    },

    // Mark every unanswered question's ansNotSubmit flag; returns whether any were unanswered
    markUnansweredQuestions() {
      let hasUnanswered = false;

      for (let section of this.quizSectionData) {
        for (let question of section.questionList) {
          if (question.subjectiveFlag) {
            if (this.isQuestionUnanswered(question)) {
              question.ansNotSubmit = true;
              hasUnanswered = true;
            }
          } else {
            // objective: at least one answer must be selected
            const unanswered = this.isQuestionUnanswered(question);
            question.ansNotSubmit = unanswered;
            if (unanswered) hasUnanswered = true;
          }
        }
      }

      return hasUnanswered;
    },

    // Handle what happens when the time is up (e.g., submit quiz)
    onTimeUp() {
      this.calculateElapsedTime();

      // F03 DSD — คอร์ส DSD: หมดเวลาแล้วส่งอัตโนมัติทันที ไม่เปิด incompleteSubmitDialog (D-Q6)
      if (this.isDsdMode) {
        this.markUnansweredQuestions();
        this.dsdTimeUp = true;
        this.submitQuiz();
        return;
      }

      const hasUnanswered = this.markUnansweredQuestions();

      if (hasUnanswered) {
    // ✅ Show a warning dialog instead of submitting automatically
    this.incompleteSubmitDialog = true; // you already use this
    this.finishQuizOnTime = false;
    return;
  }

  // ✅ If all answered, go ahead and submit automatically
  this.submitQuiz();
},

    // Calculate elapsed time based on remaining time
    calculateElapsedTime() {
      this.elapsedTime = this.initialTime - this.remainingTime;
    },

    // Format the time as minutes and seconds (MM:SS)
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    },
     Click_ok() {
      this.resultDialog = false;
      globalThis.messageHandler.postMessage("GoBack");
    },

    showImgPreview(image) {
      this.previewimg = true;
      this.picturePreview = image;
    },

    viewAnswerResult() {
      this.resultDialog = false; // hide result dialog.
      this.viewAnswer = true;
      //push first index 0 to show first
      this.section_Items = [];
      this.section_Items.push(this.quizSectionData[0]);

      // button controls...
      this.lastQuizSection = this.quizSectionData.length <= 1; // hide submit button
      this.nextQuizSection = false; // won't show back button when start the quiz again
      this.resultDialog = false; // hide score dialog
    },

    doQuizAgain() {
      this.nextQuizSection = false; // won't show back button when start the quiz again
      this.resultDialog = false; // hide score dialog
      globalThis.messageHandler.postMessage("GoBack");
    },

    clickBack() {
      let currentSectionIndex = this.quizSectionData
        .map(function (e) {
          return e.sectionId;
        })
        .indexOf(this.section_Items[0].sectionId);

      if (this.quizSectionData[currentSectionIndex - 1] != undefined) {
        this.quizSectionData[currentSectionIndex] = this.section_Items[0];

        //pushing edited section data to this.section_Items
        this.section_Items = [];
        this.section_Items.push(this.quizSectionData[currentSectionIndex - 1]);

        this.nextQuizSection = currentSectionIndex - 1 != 0; // if its firt index hide next button.
        this.lastQuizSection = false; // when going back to previous section, hide submit button..
      }
    },
    clickFinished() {
      globalThis.messageHandler.postMessage("GoBack");
    },

    clickNext() {
      //to go to next quiz section....
      //1.first save user's edit answer from section_Items to QuizData by matching sectionId
      let currentSectionIndex = 0;

      for (let question of this.section_Items[0].questionList) {
        let notChooseAns2 = !question.choiceList.some(
          (k) => k.userAnswer === true
        );
        question.ansNotSubmit = notChooseAns2;
      }

      let answerNotSubmit = this.section_Items[0].questionList.some(
        (x) => x.ansNotSubmit === true
      );

      if (answerNotSubmit) {
        //user did not submit/choose any answer so cannot pass through
        return;
      }

      currentSectionIndex = this.quizSectionData
        .map(function (e) {
          return e.sectionId;
        })
        .indexOf(this.section_Items[0].sectionId);
      if (this.quizSectionData[currentSectionIndex + 1] != undefined) {
        //enter this condition because there is still next available section.

        //put update data into its index .....
        this.quizSectionData[currentSectionIndex] = this.section_Items[0];

        //pushing new or next section data to this.section_Items
        this.section_Items = [];
        this.section_Items.push(this.quizSectionData[currentSectionIndex + 1]);

        this.nextQuizSection = currentSectionIndex + 1 != 0;

        if (
          this.section_Items[0].sectionId ==
          this.quizSectionData[this.quizSectionData.length - 1].sectionId
        ) {
          this.lastQuizSection = true;
        } else {
          this.lastQuizSection = false;
        }
      }
    },

    clickNextForAnswerCheck() {
      //to go to next quiz section....
      //1.first save user's edit answer from section_Items to QuizData by matching sectionId
      let currentSectionIndex = 0;

      for (let question of this.section_Items[0].questionList) {
        let notChooseAns2 = !question.choiceList.some(
          (k) => k.userAnswer === true
        );
        question.ansNotSubmit = notChooseAns2;
      }

      currentSectionIndex = this.quizSectionData
        .map(function (e) {
          return e.sectionId;
        })
        .indexOf(this.section_Items[0].sectionId);
      if (this.quizSectionData[currentSectionIndex + 1] != undefined) {
        //enter this condition because there is still next available section.

        //put update data into its index .....
        this.quizSectionData[currentSectionIndex] = this.section_Items[0];

        //pushing new or next section data to this.section_Items
        this.section_Items = [];
        this.section_Items.push(this.quizSectionData[currentSectionIndex + 1]);

        this.nextQuizSection = currentSectionIndex + 1 != 0;

        if (
          this.section_Items[0].sectionId ==
          this.quizSectionData[this.quizSectionData.length - 1].sectionId
        ) {
          this.lastQuizSection = true;
        } else {
          this.lastQuizSection = false;
        }
      }
    },

    updateChoiceAnswer(item, subitem, cho_id) {
      if (item.multipleChoice === false) {
        // for single choice ans
        subitem.userAnswer = subitem.choiceId == cho_id ? true : null;
        return;
      }
      // for multiple choice ans
      if (subitem.choiceId == cho_id) {
        subitem.userAnswer = subitem.userAnswer === false ? null : true;
      }
    },
    checkCorrectAns(que_id, cho_id) {
      //finding current section's question's choices
      let current_Que = this.section_Items[0].questionList.filter(
        (x) => x.questionId == que_id
      );

      for (let item of current_Que) {
        for (let subitem of item.choiceList) {
          this.updateChoiceAnswer(item, subitem, cho_id);
        }

        item.ansNotSubmit = !item.choiceList.some(
          (k) => k.userAnswer === true
        );
      }
    },
    normalizeChoice(choice) {
      return {
        ...choice,
        userAnswer: choice.userAnswer ?? false,
      };
    },

    buildQuestionFromResponse(question) {
      let updatedQuestion = {
        ...question,
        ansNotSubmit: false,
        thisQuesRusult: 0,
        radio_UserChoice: question.radio_UserChoice || null,
        radio_masterChoice:
          question.multipleChoice === false
            ? question.choiceList.find(
                (k) => k.choiceAnswerMaster === true
              )?.choiceId || null
            : null,
      };
      if (question.subjectiveFlag) {
        updatedQuestion.userAnswerText = question.userAnswerText || "";
      } else {
        updatedQuestion.choiceList = question.choiceList.map((choice) =>
          this.normalizeChoice(choice)
        );
      }

      return updatedQuestion;
    },

    async GetQuizMasterDetail() {
      this.itemsList = [];
      this.loading = true;
      let request = {
        quizId: this.$route.query.quizid,
        companyId: this.$route.query.companyID,
        mobile: true,
        offset: 0,
      };

      await axios
        .post(`${this.web_urlV4}Quiz/GetQuizMasterDetail`, request)
        .then((response) => {
          if (response.data.status == 0) {
            this.quiz_Data = response.data.data;

            // Timer setup
            this.hasTimer = response.data.data.timer > 0;
            this.remainingTime = response.data.data.timer * 60;
            this.initialTime = response.data.data.timer * 60;

            let temp = response.data.data.sectionList;
            this.lastQuizSection = temp.length <= 1;

            // Build reactive quizSectionData
            this.quizSectionData = temp.map((section) => {
              return {
                ...section,
                questionList: section.questionList.map((question) =>
                  this.buildQuestionFromResponse(question)
                ),
              };
            });

            // Show only the first section initially
            this.section_Items.push(this.quizSectionData[0]);
            // F03 DSD — โหลดกฎ DSD แบบไม่ await (ผู้เรียนเริ่มอ่านข้อสอบได้เลย; ปุ่มส่งรอจนรู้โหมด)
            this.loadDsdRule();
          }

          // Scores and settings
          this.full_score = response.data.data.fullScore ;
          this.showPassingScore = response.data.data.showPassingScore;
          this.passing_score = response.data.data.passingScore || 0;
          this.show_CorrectAns1 =
            this.quiz_Data.showCorrectAnswerAfterCompletion;
          this.show_CorrectAns2 = this.quiz_Data
            .showCorrectAnswerAfterCompletion
            ? this.quiz_Data.showCorrectAnswer
            : false;
          this.show_score = this.quiz_Data.showScore;

          this.loading = false;
          this.startTimer();
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });

      this.loading = false;
    },
     
    gradeSubjectiveQuestion(question) {
      if (
        question.userEssayAnswer &&
        question.userEssayAnswer.trim() !== ""
      ) {
        question.ansNotSubmit = false;
        question.thisQuesRusult = 0;
      } else {
        question.ansNotSubmit = true;
      }
      return 0;
    },
    gradeSingleChoiceQuestion(question) {
      let ans =
        question.choiceList.find(
          (x) => x.choiceAnswerMaster === true && x.userAnswer === true
        )?.choiceId ?? null;

      let score = 0;
      if (ans == question.radio_masterChoice) {
        score = question.questionScore;
        question.thisQuesRusult = question.questionScore;
      }

      question.ansNotSubmit = !question.choiceList.some(
        (k) => k.userAnswer === true
      );

      return score;
    },
    gradeMultipleChoiceQuestion(question) {
      let correctAns = 0;
      let masterAns = 0;
      let wrongAns = 0;

      for (let choice of question.choiceList) {
        if (choice.choiceAnswerMaster === true) {
          masterAns += 1;
        }
        if (
          choice.choiceAnswerMaster === true &&
          choice.userAnswer === true
        ) {
          correctAns += 1;
        }
        if (
          choice.choiceAnswerMaster === false &&
          choice.userAnswer === true
        ) {
          wrongAns += 1;
        }
      }

      question.ansNotSubmit = !question.choiceList.some(
        (k) => k.userAnswer === true
      );

      if (wrongAns != 0) {
        question.thisQuesRusult = 0;
        return 0;
      }
      if (masterAns == correctAns) {
        question.thisQuesRusult = question.questionScore;
        return question.questionScore;
      }
      return 0;
    },
    gradeQuestion(question) {
      if (question.subjectiveFlag === true) {
        return this.gradeSubjectiveQuestion(question);
      }
      if (question.multipleChoice === false) {
        return this.gradeSingleChoiceQuestion(question);
      }
      return this.gradeMultipleChoiceQuestion(question);
    },
    gradeQuizSections() {
      let userScore = 0;
      let notAnswerQuoCount = 0;
      let totalQuoCount = 0;

      for (let section of this.quizSectionData) {
        for (let question of section.questionList) {
          userScore += this.gradeQuestion(question);
        }

        notAnswerQuoCount += section.questionList.filter(
          (x) => x.ansNotSubmit
        ).length;
        totalQuoCount += section.questionList.length;
      }

      return { userScore, notAnswerQuoCount, totalQuoCount };
    },
    calculateAnsweredCount(notAnswerQuoCount, totalQuoCount) {
      if (notAnswerQuoCount === 0) {
        return totalQuoCount;
      }
      if (notAnswerQuoCount === totalQuoCount && notAnswerQuoCount !== 0) {
        return 0;
      }
      return totalQuoCount - notAnswerQuoCount;
    },
    buildQuizSubmissionPayload(userScore) {
      return {
        quizId: this.quiz_Data.quizId,
        courseId: this.quiz_Data.courseId,
        userId: Number.parseInt(this.$route.query.userID),
        companyId: this.$route.query.companyID,
        quizName: this.quiz_Data.quizName,
        courseName: this.quiz_Data.courseName,
        createOrUpdateBy: this.$route.query.memberID,
        showCorrectAnswerAfterCompletion:
          this.quiz_Data.showCorrectAnswerAfterCompletion,
        showCorrectAnswer: this.quiz_Data.showCorrectAnswer,
        showScore: this.quiz_Data.showScore,
        score: userScore,
        fullScore: this.quiz_Data.fullScore,
        passingScore: this.quiz_Data.passingScore,
        showPassingScore: this.quiz_Data.showPassingScore,
        quizType: Number.parseInt(this.$route.query.quizType),
        sectionList: this.quizSectionData.map((k) => ({
          ...k,
          questionList: k.questionList.map((x) => ({
            questionId: x.questionId,
            questionNo: x.questionNo,
            questionScore: x.questionScore,
            question: x.question,
            questionImge: x.questionImge,
            multipleChoice: x.subjectiveFlag
              ? false
              : x.multipleChoice ?? false,
            essayAnswer: x.essayAnswer ?? false,
            aiChecking: x.aiChecking ?? false,
            correctAnswer: x.correctAnswer ?? "",
            subjectiveFlag: x.subjectiveFlag ?? false,
            userEssayAnswer: x.userEssayAnswer ?? "",
            choiceList: x.choiceList.map((v) => ({
              choiceId: v.choiceId,
              choiceNo: v.choiceNo,
              choice: v.choice,
              choiceImge: v.choiceImge,
              choiceAnswerMaster: v.choiceAnswerMaster,
              userAnswer: v.userAnswer,
            })),
          })),
        })),
      };
    },
    handleSubmitQuizResponse(res, notAnswerQuoCount, totalQuoCount, tempAnsweredQuo) {
      if (res.data.status != 0) {
        this.loading = false;
        alert("Something went wrong when submit!");
        this.Click_ok();
        return;
      }

      if (this.hasTimer) {
        let incompleteAnsSubmit = false;

        // Check if there is still time left
        if (this.remainingTime > 0) {
          if (notAnswerQuoCount === totalQuoCount) {
            // Time remaining, but no questions answered
            this.notTakeQuizAndSubmit = true;
          } else {
            // Some questions answered but not all
            this.notTakeQuizAndSubmit = false;
            incompleteAnsSubmit =
              tempAnsweredQuo !== totalQuoCount && notAnswerQuoCount !== 0;
          }
          this.finishQuizOnTime = true;
        } else {
          // Time is up
          this.finishQuizOnTime = tempAnsweredQuo === totalQuoCount;
        }

        // Determine dialog to show based on submission status
        this.incompleteSubmitDialog = incompleteAnsSubmit;
        this.timerDialog = !incompleteAnsSubmit;
      } else {
        // No timer present, show result dialog
        this.resultDialog = true;
      }

      this.loading = false;
    },
    async submitQuiz() {
      if (this.hasTimer) {
        this.stopTimer();
        this.calculateElapsedTime();
      }

      const { userScore, notAnswerQuoCount, totalQuoCount } =
        this.gradeQuizSections();

      const tempAnsweredQuo = this.calculateAnsweredCount(
        notAnswerQuoCount,
        totalQuoCount
      );

      this.answeredQuo = tempAnsweredQuo + "/" + totalQuoCount;
      this.user_score = userScore;

      const temp_quiz = this.buildQuizSubmissionPayload(userScore);
      this.loading = true;

      // F03 DSD — คอร์ส DSD ส่งไป v7 SubmitUserQuiz (server คิดคะแนนเอง) — ไม่ใช่ DSD ใช้ทางเดิม v4 ด้านล่าง
      if (this.isDsdMode) {
        await this.submitQuizDsd(temp_quiz, notAnswerQuoCount, totalQuoCount, tempAnsweredQuo);
        return;
      }

      //Before submit, whether to submit or show re-quiz
      this.passQuiz = userScore >= this.quiz_Data.passingScore;

      console.log(
        "🚀 ~ temp_quiz payload:",
        JSON.stringify(temp_quiz, null, 2)
      );

      // submit the quiz whether pass or fail
      const res = await this.$axios.post(
        `${this.web_urlV4}Quiz/AddUserQuiz`,
        temp_quiz
      );

      this.handleSubmitQuizResponse(
        res,
        notAnswerQuoCount,
        totalQuoCount,
        tempAnsweredQuo
      );
    },
    // F03 DSD — v7 GetQuizAssessmentRule: timeout 10 วิ + retry 1 ครั้ง → ยังล้มเหลว = dsdRule null (ทางเดิม v4)
    async loadDsdRule() {
      this.dsdRuleLoading = true;
      const request = {
        quizId: this.$route.query.quizid,
        companyId: this.$route.query.companyID,
      };
      let rule = null;
      for (let attempt = 0; attempt < 2 && rule === null; attempt++) {
        rule = await axios
          .post(`${this.web_urlV7}Quiz/GetQuizAssessmentRule`, request, { timeout: 10000 })
          .then((res) => (res.data && res.data.status == 0 && res.data.data ? res.data.data : null))
          .catch(() => null);
      }
      this.dsdRule = rule;
      this.dsdRuleLoading = false;
    },
    // F03 DSD — ส่ง v7: status 0 → ใช้ flow timer/result เดิม; อื่น ๆ → dsdSubmitErrorDialog (ไม่เรียก handleSubmitQuizResponse ที่ alert อังกฤษ)
    async submitQuizDsd(temp_quiz, notAnswerQuoCount, totalQuoCount, tempAnsweredQuo) {
      this.dsdResult = null;
      const res = await this.$axios
        .post(`${this.web_urlV7}Quiz/SubmitUserQuiz`, temp_quiz)
        .catch(() => null);
      if (res && res.data && res.data.status == 0 && res.data.data) {
        const d = res.data.data;
        this.user_score = d.totalScore;
        this.full_score = d.fullScore;
        this.passQuiz = d.resultStatus !== "FAILED"; // UX-F5b — PENDING_REVIEW ไม่ขึ้นปุ่มทำใหม่
        this.dsdResult = d;
        this.handleSubmitQuizResponse(res, notAnswerQuoCount, totalQuoCount, tempAnsweredQuo);
        return;
      }
      this.loading = false;
      this.openDsdSubmitError(res);
    },
    // F03 DSD — map errors[0].code → i18n (ไม่แสดง message อังกฤษจาก API — A11)
    openDsdSubmitError(res) {
      const errors =
        res && res.data && res.data.status == 1 && res.data.data && Array.isArray(res.data.data.errors)
          ? res.data.data.errors
          : [];
      const code = errors.length > 0 && errors[0] ? errors[0].code : "";
      const finalKeys = {
        QUIZ_CHANGED: "quizchanged",
        QUIZ_LIMIT_REACHED: "quizlimitreached",
        USER_NOT_ASSIGNED: "quiznotassigned",
      };
      if (finalKeys[code]) {
        this.dsdSubmitErrorKey = finalKeys[code];
        this.dsdSubmitRetryable = false;
      } else {
        this.dsdSubmitErrorKey = "quizsubmitfailed"; // network/timeout, status 2, status 1 code อื่น/ไม่มี errors
        this.dsdSubmitRetryable = true;
      }
      this.dsdSubmitErrorDialog = true;
    },
    // F03 DSD — ส่งอีกครั้ง: คำตอบยังอยู่ใน quizSectionData; loading dialog เดิมกันกดซ้ำ
    dsdSubmitRetry() {
      this.dsdSubmitErrorDialog = false;
      this.submitQuiz();
    },
    // F03 DSD — ออกจากแบบทดสอบ / ตกลง
    dsdSubmitExit() {
      this.dsdSubmitErrorDialog = false;
      this.goBack();
    },
    // F03 DSD — ปิด webview (ใช้ใน <script> เท่านั้น — template ห้าม globalThis) UX-F6
    goBack() {
      if (window.messageHandler) window.messageHandler.postMessage("GoBack");
    },

  },
};
</script>

<style scoped>
/* disable radio color */
::v-deep
  .disable_radio_green.v-input--radio-group.theme--light.v-input--is-disabled {
  color: #4fb14e !important;
}
::v-deep
  .disable_radio_grey.v-input--radio-group.theme--light.v-input--is-disabled {
  color: #a4a4a4 !important;
}
/* end disabled radio color */
/* disabled checkbox color */
::v-deep .disable_green.v-input--checkbox.theme--light.v-input--is-disabled {
  color: #4fb14e !important;
}
::v-deep .disable_grey.v-input--checkbox.theme--light.v-input--is-disabled {
  color: #a4a4a4 !important;
}
/* end disabled checkbox */
::v-deep .option_sheet.v-list-item-group .v-list-item--active {
  color: #ffff;
}
::v-deep .v-image__image--cover {
  border-radius: 14px;
}
/* Keep all quiz images inside their container even when template uses
   fixed widths such as 445px, 205px, 170px, or 800px. */
::v-deep .v-image {
  max-width: 100% !important;
  box-sizing: border-box;
}
::v-deep .v-image[style*="width"] {
  max-width: 100% !important;
}
::v-deep .preview_class {
  max-width: calc(100vw - 24px) !important;
  margin: 12px;
}
::v-deep .preview_class .v-card,
::v-deep .preview_class .v-image {
  max-width: 100% !important;
}
@media (max-width: 600px) {
  ::v-deep .v-image.ml-5 {
    margin-left: 0 !important;
  }
  ::v-deep .preview_class .v-image {
    max-height: calc(100vh - 120px) !important;
  }
}
::v-deep .v-btn:not(.v-btn--round).v-size--default {
  min-width: unset !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: transparent !important;
}
::v-deep .v-btn__content {
  padding-top: 2px !important;
}

/* ===== Quiz answer-review image choice cards: responsive fix =====
   The view-answer image-choice <v-card> uses fixed height=169 / width=225
   which makes long Thai labels and the choice image overflow and overlap
   adjacent cards inside narrow mobile webviews. Make them responsive. */
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] {
  height: auto !important;
  min-height: 169px;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
  margin-left: 0 !important;
  padding-right: 8px;
}
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] .v-image {
  width: 100% !important;
  max-width: 100% !important;
}
@media (max-width: 600px) {
  ::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] {
    max-width: 100% !important;
    width: 100% !important;
  }
  ::v-deep .option_sheet .v-list-item-content span,
  ::v-deep .v-input--selection-controls .v-label {
    white-space: normal !important;
    overflow-wrap: break-word;
    line-height: 1.3 !important;
  }
}
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] .v-label {
  white-space: normal !important;
  overflow-wrap: break-word;
  line-height: 1.3 !important;
  font-size: 13px !important;
  max-width: 100%;
}
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] .v-input--selection-controls__input {
  align-self: flex-start;
}
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] > .row > .col:first-child,
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] > .row > [class*="col-"]:first-child {
  flex: 1 1 auto !important;
  max-width: none !important;
  min-width: 0;
}
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] > .row > .col:last-child,
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"] > .row > [class*="col-"]:last-child {
  flex: 0 0 36px !important;
  max-width: 36px !important;
}

/* Keep image-answer highlight full-width in the two-column desktop layout
   and single-column mobile webview layout. */
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"][style*="#A6CC391C"],
::v-deep .v-card[style*="height: 169px"][style*="width: 225px"][style*="#FF60601F"] {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
}

/* ===== Fix #2: text overlap + partial-width colored highlight bars ===== */
::v-deep .viewans_.v-list-item {
  height: auto !important;
  min-height: 40px !important;
  align-items: flex-start;
}
::v-deep .viewans_ .v-list-item__content {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
::v-deep .viewans_ .v-list-item__content span {
  white-space: normal !important;
  overflow-wrap: break-word;
  line-height: 1.4 !important;
  display: block;
}
::v-deep .viewans_ .v-list-item__action {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
  align-self: flex-start;
}
::v-deep .viewans_[style*="background"] {
  width: 100% !important;
  display: flex;
  align-items: stretch;
}
@media (max-width: 600px) {
  ::v-deep .option_sheet { padding: 0 !important; }
  ::v-deep .viewans_.v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

/* ===== Fix #3: catch every highlighted element so colored bars are always full-width ===== */
/* Only force full width on OUTER row wrappers, never inner v-col children. */
::v-deep .viewans_[style*="#A6CC391C"],
::v-deep .viewans_[style*="#FF60601F"],
::v-deep .v-list-item.pl-7.mr-2 > .row[style*="#A6CC391C"],
::v-deep .v-list-item.pl-7.mr-2 > .row[style*="#FF60601F"] {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
::v-deep .v-list-item.pl-7.mr-2 {
  width: 100% !important;
  padding-left: 4px !important;
  margin-right: 0 !important;
  display: flex;
  align-items: stretch;
}
::v-deep .v-list-item.pl-7.mr-2 > .col,
::v-deep .v-list-item.pl-7.mr-2 > [class*="col-"] {
  flex: 0 0 auto !important;
}
::v-deep .v-list-item.pl-7.mr-2 > .col:first-child,
::v-deep .v-list-item.pl-7.mr-2 > [class*="col-"]:first-child {
  flex: 1 1 auto !important;
  max-width: none !important;
  min-width: 0;
}
::v-deep .v-list-item.pl-7.mr-2 > .col:last-child,
::v-deep .v-list-item.pl-7.mr-2 > [class*="col-"]:last-child {
  flex: 0 0 36px !important;
  max-width: 36px !important;
}
::v-deep .v-list-item.pl-7.mr-2 .v-label {
  white-space: normal !important;
  overflow-wrap: break-word;
  line-height: 1.4 !important;
  max-width: 100%;
}
</style>
